<!-- 顶部导航组件 -->
<template>
  <div class="page">
    <div class='top'>

      <img src="../../images/logo.png"
           class="top__logo"
           alt="">
      <ul style=""
          class="top__nav">
        <li class="top__nav__item"
            :class="{'top__nav__item--first':index == 0,'active':curIndex == index}"
            v-for="(item,index) in items"
            :key=item.id
            @click="clickItem(index)">
          <span>{{ item.title }}</span>
          <div class="top__nav__item__underline"
               v-show="curIndex == index"></div>
        </li>

      </ul>
      <!-- <div class="top__btn__login" :class="{'top__bton__login--press':isPress}">登录</div> -->
      <GButton text="登录"
               width="100px"
               height="38px"
               @click="btnClick"></GButton>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TopNav',
  components: {},
  props: {
    items: [],
    defaultIndex: Number
  },
  data () {
    return {
      curIndex: this.defaultIndex || 0
    }
  },
  computed: {},
  watch: {

  },
  // 方法集合
  methods: {
    clickItem (index) {
      this.curIndex = index
      this.$emit('itemClick', { index: index, item: this.items[index] })
    },
    btnClick () {

    }
  },
  created () {
    this.$watch(
      () => this.$route,
      (route) => {
        if (route.path.indexOf('home') !== -1) {
          this.curIndex = 0
        } else if (route.path.indexOf('service') !== -1) {
          this.curIndex = 1
        } else if (route.path.indexOf('actuate') !== -1) {
          this.curIndex = 2
        } else if (route.path.indexOf('about') !== -1) {
          this.curIndex = 3
        }
      }, { immediate: true }
    )
  },
  mounted () {
    if (this.$route.path.indexOf('home') !== -1) {
      this.curIndex = 0
    } else if (this.$route.path.indexOf('service') !== -1) {
      this.curIndex = 1
    } else if (this.$route.path.indexOf('actuate') !== -1) {
      this.curIndex = 2
    } else if (this.$route.path.indexOf('about') !== -1) {
      this.curIndex = 3
    }
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.page {
}
.top {
  color: #333333;
  padding: 0px 360px;
  height: 64px;
  // line-height: 64px;
  display: flex;
  align-items: center;
  background-color: white;
  .top__logo {
    width: 110px;
    height: 38px;
  }
  .top__nav {
    padding: 0;
    padding-top: 5px;
    margin-left: 64px;
    display: inline-block;

    list-style-type: none;
    flex-grow: 1;
    .top__nav__item {
      user-select: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 64px;
      float: left;
      &:hover {
        color: $color-primary;
        cursor: pointer;
        font-weight: bold;
      }
      .top__nav__item__underline {
        height: 2px;
        width: 80%;
        margin-top: 5px;
        background-color: #333333;
      }
    }
    .active {
      font-weight: 500;
    }
    .top__nav__item--first {
      margin-left: 0px !important;
    }
  }
  .top__btn__login {
    display: inline-block;
    color: white;
    padding: 7px 34px;
    user-select: none;
    background-color: $color-primary;
    border-radius: 4px;
    &:hover {
      cursor: pointer;
      background-color: #497aff;
    }
  }
}
</style>
